export const enum WARNING_MESSAGE {
  useInviteLink = 'Please use the invite link to continue registration',
  somethingWentWrong = 'Something went wrong.Please reload page and try again',
  isHPA = 'The registration has already been created for you. Please wait for changes in your email',
  notAccess = `You don't have access to the registration. Please use the invite link to continue registration`,
}
